import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default createReactClass({
  propTypes: {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    manager: PropTypes.object,
    element: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    request: PropTypes.object,
  },

  childContextTypes: {
    manager: PropTypes.object,
    request: PropTypes.object,
  },

  getDefaultProps() {
    return {
      element: 'div',
    };
  },

  getChildContext() {
    return {
      manager: this.props.manager,
      request: this.props.request,
    };
  },

  render() {
    const wrap = (children) => {
      return React.createElement(this.props.element, {}, children);
    };

    return (React.Children.count(this.props.children) === 1) ? this.props.children : wrap(this.props.children);
  },
});



// WEBPACK FOOTER //
// ./app/javascript/requests/components/ResourcesMatching.js